import classNames from 'classnames';

const generateConditionalClassNames = (base, params)=>{
    return classNames(base, {
        [`${base}--full-width`]: params.fullWidth === 'true',
        [`${base}--align-left`]: params.horizontalAlignment === 'left',
        [`${base}--align-center`]: params.horizontalAlignment === 'center',
        [`${base}--align-right`]: params.horizontalAlignment === 'right',
        [`${base}--align-top`]: params.verticalAlignment === 'top',
        [`${base}--align-middle`]: params.verticalAlignment === 'center',
        [`${base}--align-bottom`]: params.verticalAlignment === 'bottom',
        [`${base}--hide-on-mobile`]: params.showInPhone === 'false',
        [`${base}--hide-on-tablet`]: params.showInTablet === 'false',
        [`${base}--hide-on-desktop`]: params.showInDesktop === 'false'
    });
};
const extractSkusFromBrParameters = (parameters)=>Object.keys(parameters).filter((key)=>key.startsWith('sku') && typeof parameters[key] === 'string' && parameters[key].trim() !== ''
    ).map((key)=>parameters[key].trim()
    )
;
const removeWhiteSpaceChars = (string)=>{
    return string.replace(/\s/g, '');
};
const scrollToNextTab = (tabRefs, index)=>{
    const button = tabRefs.current[index];
    if (button) {
        const tabsContainer = button.closest('.br-row-tabs');
        const slidesWrapper = tabsContainer ? tabsContainer.querySelector('.br-row-tabs_slides-wrapper') : null;
        if (slidesWrapper && slidesWrapper instanceof HTMLElement) {
            slidesWrapper.style.transform = `translate(calc(-100%/7*${index}))`;
        }
    }
};

export { extractSkusFromBrParameters, generateConditionalClassNames, removeWhiteSpaceChars, scrollToNextTab };
//# sourceMappingURL=utils.js.map
